import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../store';
import { useUpgradeToAnnualMutation } from '../../../../hooks/usePricingEndpoints';
import { PurchaseDialogStep } from '../../entities/PurchaseDialogStep';
import CongratulationsStep from '../molecules/CongratulationsStep';
import PaymentStep from '../molecules/PaymentStep';
import BasePurchaseDialog from './BasePurchaseDialog';

const PaymentStepCallback = () => <PaymentStep paymentInfoIsAlreadySaved />;

export default function UpgradeToAnnualDialog() {
  const { t } = useTranslation('Pricing');
  const { isUpgradeToAnnualDialogOpen, selectedProduct, termsAndConditionsAccepted } = useAppSelector(
    (state) => state.purchase,
  );
  const [upgradeToAnnual] = useUpgradeToAnnualMutation();

  const steps: PurchaseDialogStep[] = [
    {
      component: PaymentStepCallback,
      nextButtonGradient: 'contained',
      nextButtonText: t('PurchaseDialog.ConfirmPurchase'),
      validForm: termsAndConditionsAccepted,
      backButton: false,
      fullStoryName: 'Payment',
    },
    {
      component: CongratulationsStep,
      nextButtonGradient: 'gradient',
      nextButtonText: t('PurchaseDialog.AccessDashboard'),
      validForm: true,
      backButton: false,
      fullStoryName: 'Congratulations',
    },
  ];

  const save = async () => {
    await upgradeToAnnual({ productId: selectedProduct.id }).unwrap();
  };

  return (
    <BasePurchaseDialog
      isDialogOpen={isUpgradeToAnnualDialogOpen}
      steps={steps}
      onSave={save}
      fullstoryEventPrefix="Upgrade to Annual Flow"
    />
  );
}
